var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 44.702,
    viewBox: "0 0 55 44.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "contact_twitter",
    d: "M54.892,7.569a22.917,22.917,0,0,1-6.474,1.776,11.362,11.362,0,0,0,4.957-6.24A23.289,23.289,0,0,1,46.21,5.819a11.271,11.271,0,0,0-19.5,7.7A11.538,11.538,0,0,0,27,16.089,31.932,31.932,0,0,1,3.758,4.343a11.05,11.05,0,0,0-1.526,5.672A11.276,11.276,0,0,0,7.246,19.4,11.239,11.239,0,0,1,2.14,17.989v.14A11.281,11.281,0,0,0,11.183,29.19a11.378,11.378,0,0,1-5.069.195,11.313,11.313,0,0,0,10.55,7.83A22.613,22.613,0,0,1,2.681,42.039,23.932,23.932,0,0,1,0,41.886a32.071,32.071,0,0,0,17.317,5.062c20.748,0,32.08-17.178,32.08-32.05,0-.479,0-.962-.034-1.444A22.769,22.769,0,0,0,55,7.615l-.108-.046Z",
    transform: "translate(0 -2.246)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactTwitter);
export default __webpack_public_path__ + "static/media/contact_twitter.c2576f4853f4b2e5141f9b41ba4d1f63.svg";
export { ForwardRef as ReactComponent };